export default __webpack_public_path__ + "static/media/banner-top.87831ac1.png";